import React from 'react';
import { FloatingTabStyled, CloseIcon } from './floatingTab.styled';
import Box from '../Box';

interface TabProps {
  className?: string;
  value?: string;
  active?: boolean;
  closable?: boolean;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  onClose?: (value: string) => void;
  children?: React.ReactNode | React.ReactNode[];
}

const FloatingTab = ({
  value,
  active,
  closable,
  onClick,
  onClose,
  children,
  className = '',
  style,
}: TabProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick(event, value);
  };

  const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    onClose(value);
  };

  return (
    <FloatingTabStyled
      style={style}
      active={active}
      className={className}
      onClick={handleClick}
    >
      {children}
      {closable ? (
        <Box ml={3} sx={{ display: 'inline-flex' }}>
          <CloseIcon
            name='close'
            size='xsmall'
            onClick={handleIconClick}
            active={active}
          />
        </Box>
      ) : null}
    </FloatingTabStyled>
  );
};

export default FloatingTab;
